import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { makeGraphQlCall } from '../../utils/graphql';
import {
  DocumentVSku,
  EndpointConfig,
  VSkuType,
  errorGetEndpoint,
  finishGetEndpoint,
  startGetEndpoint,
  startGetEndpointByAlias,
} from './endpointSlice';

const endpointQueryResponse = `
  customer {
    customerId
    customerLogo
    customerName
  }
  endpointId
  isDemo
  redirectSettings {
    includeUser
    redirectUri
  }
  vspecs {
    vsku {
      vsku
      nameId
      descriptionId
      disclaimerId
      documentType
      documentReference
      footerId
      titleId
      type
      jurisdiction
      inputClaims {
        nameId
        errorId
        isRequired
        fieldName
        label
        isPrimary
        isDerived
        isHidden
        dataType
        options {
          copyParam
          copyClaim
          values {
            value
            label
            labelStringId
          }
          multiple {
            min
            max
          }
          maskType
          requiredSet
        }
      }
      outputResults {
        nameId
        errorId
        isRequired
        fieldName
        label
        isPrimary
        isDerived
        isHidden
        dataType
        options {
          copyParam
          copyClaim
          values {
            value
            label
          }
        }
      }
      requiredInputs
      primaryInputs
      inputCategories
      requiredOutputs
      allowMultiples
      allowSkip
    }
    vspecId
  }
  parameters {
    key
    value
  }
`;

const getEndpointByAliasQuery = `query GetEndpointByAlias($alias: String!) {
  getEndpointByAlias(alias: $alias) {
    ${endpointQueryResponse}
  }
}`;

const getEndpointQuery = `query GetEndpoint($endpointId: String!) {
  getEndpoint(endpointId: $endpointId) {
    ${endpointQueryResponse}
  }
}`;

function* handleStartGetEndpoint(action: PayloadAction<string>) {
  console.log('Starting getEndpoint');
  try {
    const data: { getEndpoint: EndpointConfig } = yield call(makeGraphQlCall, {
      query: getEndpointQuery,
      variables: { endpointId: action.payload },
    });
    yield put(finishGetEndpoint(data.getEndpoint));
  } catch (e) {
    console.log('got error', e);
    yield put(errorGetEndpoint(e.message));
  }
}

function* handleStartGetEndpointByAlias(action: PayloadAction<string>) {
  console.log('Starting getEndpoint with alias');
  try {
    const data: { getEndpointByAlias: EndpointConfig } = yield call(
      makeGraphQlCall,
      {
        query: getEndpointByAliasQuery,
        variables: { alias: action.payload },
      }
    );
    yield put(finishGetEndpoint(data.getEndpointByAlias));
  } catch (e) {
    console.log('got error', e);
    yield put(errorGetEndpoint(e.message));
  }
}

function* endpointSaga() {
  yield takeEvery(startGetEndpoint.type, handleStartGetEndpoint);
  yield takeEvery(startGetEndpointByAlias.type, handleStartGetEndpointByAlias);
}

export default endpointSaga;
